import { ChatType } from "../types/chatTypes";

export function extractFromUniqueName(uniqueName: string) {
  if (!uniqueName || typeof uniqueName !== "string") {
    throw new Error("Invalid uniqueName: must be a non-empty string");
  }

  const parts = uniqueName.split("|");
  const orderPart = parts.find((part) => part.startsWith("order:"));
  const supplierPart = parts.find((part) => part.startsWith(`${ChatType.SUPPLIER}:`));
  const customerPart = parts.find((part) => part.startsWith(`${ChatType.CUSTOMER}:`));

  if (!orderPart) {
    throw new Error("Invalid uniqueName: missing order part");
  }

  if (!supplierPart && !customerPart) {
    throw new Error("Invalid uniqueName: missing supplier or customer part");
  }

  return {
    orderNo: orderPart.replace("order:", ""),
    supplierId: supplierPart
      ? supplierPart.replace(`${ChatType.SUPPLIER}:`, "")
      : "",
    customerId: customerPart
      ? customerPart.replace(`${ChatType.CUSTOMER}:`, "")
      : "",
    chatType: supplierPart ? ChatType.SUPPLIER : ChatType.CUSTOMER,
  };
}